export default __webpack_public_path__ + "static/media/city_girl.b387716c.jpg";